import React, { Component } from 'react';

class About extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var profilepic= "images/"+this.props.data.image;
      var bio = this.props.data.bio;
      var city = this.props.data.address.city;
      var country = this.props.data.address.country;
      var linked = this.props.data.linked;
/*      var email = this.props.data.email;
       var resumeDownload = "docs/"+this.props.data.resumedownload; */
    }

    return (
      <section id="about">
      <div className="row">
         <div className="three columns header-col">
            <img className="profile-pic"  src={profilepic} alt="Leticia Valladares" />
         </div>
         <div className="seven columns main-col">
            <h2>About Me</h2>

            <p>{bio}</p>
            <div className="row">
               <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
						   <span>{name}</span><br />
						   {/* <span>{city}, {country}
                   </span><br /> */}
                   <a href={linked}><i className="fa fa-linkedin"></i></a><br />
					   </p>
               </div>
{/*                <div className="columns download">
                  <p>
                     <a href={resumeDownload} target="_blank" download={resumeDownload} className="button"><i className="fa fa-download"></i>Download Resume</a>
                  </p>
               </div> */}
            </div>
         </div>
      </div>

   </section>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/Components/About.js